<template>
	<div class="cs-block cs-blog-post-archive" :class="styleClass">
		<div class="cs-block-base">
			<div class="container">
				<div class="header-content">
					<h2 class="cs-title" v-if="data.title">
						<ColorSplit :data="data.title" />
					</h2>
					<h3 class="cs-sub-title" v-if="data.subTitle">{{ data.subTitle }}</h3>
					<span class="cs-text" v-if="data.text" v-html="data.text"></span>
				</div>
				<PostCards :posts="data.posts" :readMoreLabel="data.readMoreLabel" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "BlogPostArchive",
		components: {
			ColorSplit: () => import("../blocks_components/ColorSplit.vue"),
			PostCards: () => import("../blocks_components/PostCards.vue")
		},
		props: {
			data: {
				type: Object,
			default: () => {},
			},
		},
		data() {
			return {
				cards: [],
				page: 1,
				limit: 4,
			}
		},
		computed: {
			styleClass(){
				let result = ''

				if(this.data.style) result += ` cs-style-${this.data.style}`;

				return result
			},
		},
		mounted() {
			console.log(this)
		},
	}
</script>

<style lang="scss" scoped>
	@import "../styles/main.scss";
	.cs-blog-post-archive {
		&.cs-style- {
			&color {
				@include cs-block-color;
				.cs-title {
					color: white
				}
				.cs-sub-title {
					color: $sub_title_color;
				}

				.cs-text {
					color: $text_color_over_theme_color;

					::v-deep {
						* {
							color: $text_color_over_theme_color !important;
						}
					}
				}
			}

			&light {
				@include cs-block-light-image;

				.cs-sub-title {
					color: $sub_title_color_dark;
				}
			}

			&dark {
				@include cs-block-dark;
				.cs-sub-title {
					color: $sub_title_color_dark;
				}
			}
		}
		.header-content {
			text-align: center;
			margin-bottom: $header_margin;
			&:last-child {
				margin-bottom: 0;
			}
			.cs-title, .cs-sub-title {
				margin-bottom: 20px;
			}
			.cs-text {
				::v-deep {
					* {
						text-align: center;
					}
					img {
						max-width: 100%;
						height: 300px;
						border-radius: 10px;
						margin: 10px;
					}
					p,
					span {
						@include text;
					}
					*:last-child {
						margin-bottom: 0;
					}
				}
			}
		}
	}
</style>
